import { Prisma } from "@prisma/client";
import { FunctionComponent } from "react";
import { NodeProps, renderJSX } from "../../../lib/richText/render";
import { Heading } from "../Text/Heading";

export interface TextOptionBoxProps {
  id: string;
  index: number;
  content?: Prisma.JsonValue;
  questionId: string;
  heading: string;
  label?: string;
  note?: string;
  value?: number;
  isSelected?: boolean;
  onSelect: Function;
}

const TextOptionBox: FunctionComponent<TextOptionBoxProps> = ({
  heading,
  label,
  content,
  note,
  isSelected,
  onSelect,
}) => {
  const values: NodeProps[] = content
    ? JSON.parse(JSON.stringify(content))
    : null;
  const elements = values ? values.map((el) => renderJSX(el)) : null;
  return (
    <div
      className={`flex flex-col py-6 px-4 sm:py-8 sm:px-6 border-gray-300 border rounded-multiple-choice w-full h-full text-left cursor-pointer ${
        isSelected ? "border-primary bg-primary-light" : ""
      }`}
      onClick={() => onSelect()}
    >
      {elements || (
        <>
          <Heading level={5} className="mb-4 whitespace-pre-line">
            {heading}
          </Heading>
          <p className="text-xl text-primary font-bold leading-none">
            {label}{" "}
            <span className="text-base font-normal text-gray-500">{note}</span>
          </p>
        </>
      )}
    </div>
  );
};

export default TextOptionBox;
